import {
  LEADERBOARD_USER_LIST,
  LEADERBOARD_EXTRAPOINTS_MODAL,
  LEADERBOARD_ALL_CHALLENGES,
  LEADERBOARD_LOG_LIST_ALL,
} from "LeaderboardActions";

export const LeaderboardUserList = (state = {}, action) => {
  if (action.type == LEADERBOARD_USER_LIST) return action.payload;
  return state;
};

export const extraPointsModalReducer = (state = {}, action) => {
  if (action.type == LEADERBOARD_EXTRAPOINTS_MODAL) return action.payload;
  return state;
};

export const allGameChallengesReducer = (state = {}, action) => {
  if (action.type == LEADERBOARD_ALL_CHALLENGES) return action.payload;
  return state;
};

export const gamificationLogList = (state = {}, action) => {
  if (action.type == LEADERBOARD_LOG_LIST_ALL) return action.payload;
  return state;
};
